// components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/login_page" replace />;
    }
    return children;
};

export default ProtectedRoute;
